import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 8000);
    const hideTimer = setTimeout(() => setIsVisible(false), 18000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-292" data-mp="21xtpgov1h8ds">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" role="status" data-id="element-293" data-mp="21yvanm5rrb98">
          <div className="bg-navy-950 rounded-xl shadow-2xl border border-silver/30 p-4 pr-10 relative overflow-hidden" data-id="element-294" data-mp="1sg5z5u7mrr73">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-silver" aria-hidden="true" data-id="element-295" data-mp="1xf95dhzck3gn"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-silver-dark hover:text-silver-light p-1" aria-label="Cerrar notificación" data-id="element-296" data-mp="1jey8nybcvunk">
              <XIcon className="w-4 h-4" data-id="element-297" data-mp="1eg4xwdngehr3" />
            </button>

            <div className="flex items-start gap-3" data-id="element-298" data-mp="1ehg0wb92rlh5">
              <div className="mt-0.5 shrink-0" data-id="element-299" data-mp="zrquo1m4kra0">
                <CheckCircle2Icon className="w-5 h-5 text-silver" data-id="element-300" data-mp="zt1zm4rb452p" />
              </div>
              <div data-id="element-301" data-mp="14qv3gr550mzt">
                <p className="text-xs font-bold text-silver uppercase tracking-wider mb-1" data-id="element-302" data-mp="14o90l4t6yvnx">
                  Compra verificada
                </p>
                <p className="text-sm text-silver-light leading-tight" data-id="element-303" data-mp="vpx0mc6fqlit">
                  <strong data-id="element-304" data-mp="2xet5fdzwnecu">Marcos T.</strong> de Córdoba compró
                  <br data-id="element-305" data-mp="2xg45b2q8c1yo" />
                  <span className="text-white font-medium" data-id="element-306" data-mp="2xgnrwwqtrej1">
                    MEGAPACK CRIMINALÍSTICA LISTO 🔍🇦🇷
                  </span>
                </p>
                <p className="text-xs text-silver-dark mt-2" data-id="element-307" data-mp="2npszfamzjip5">Hace 4 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}